<span>&copy; {{'footer.title' | translate}}.</span>